const THEMES = {
  // "Garden at dusk" — the default dark palette: warm, calm, lived-in
  dark: {
    bg: "#161410",          // warm dark (brown-ish black, not cold black)
    white: "#1f1c17",       // card surface — slightly warmer
    ink: "#f4ede0",         // primary text (warm cream, not stark white)
    ink2: "#c9c2b3",        // secondary text (warm grey)
    muted: "#8a8273",       // muted text (warm grey, no green tint)
    border: "#2f2b24",      // subtle warm borders
    accent: "#7eab8e",      // softer garden green (less neon than before)
    accentLight: "#1e2520", // green-tinted dark surface
    accent2: "#d97a4a",     // softer ember orange (less aggressive)
    accent2Light: "#2a1d15",
    surface2: "#252119",    // secondary warm surface
    dark: "#0d0b08",        // deepest background — warm near-black
    darkPanel: "#0d0b08",   // for nav/sidebar/footer
  },
  // "Garden at dawn" — light variant. Deeper accents so white-on-accent
  // buttons and accent-as-text stay readable on a pale background.
  light: {
    bg: "#f7f4ec",          // warm off-white
    white: "#ffffff",       // card surface
    ink: "#211e18",         // primary text (warm near-black)
    ink2: "#514b3e",        // secondary text (warm dark grey)
    muted: "#7c7565",       // muted text
    border: "#e7e1d4",      // warm light borders
    accent: "#2d6a4f",      // deeper garden green (white text reads on it)
    accentLight: "#e6f0e9", // pale green tint
    accent2: "#c25e2e",     // deeper ember orange
    accent2Light: "#fbeadf",// pale peach
    surface2: "#f0ece2",    // secondary warm surface
    dark: "#0d0b08",        // panels stay dark in both themes
    darkPanel: "#0d0b08",   // nav/sidebar/footer stay dark
  },
};

const THEME_STORAGE_KEY = "tmp_theme";
const initialTheme =
  (typeof window !== "undefined" && window.localStorage?.getItem(THEME_STORAGE_KEY)) === "light"
    ? "light"
    : "dark";

// Live design tokens — applyTheme() mutates this object in place so the
// hundreds of inline `S.x` references pick up new values on the next render.
const S = { ...THEMES[initialTheme] };

function applyTheme(name) {
  Object.assign(S, THEMES[name] || THEMES.dark);
  if (typeof document !== "undefined" && document.body) {
    document.body.style.background = S.bg;
  }
}
applyTheme(initialTheme);

const css = {
  // Serif for brand moments (hero, promise, soulful spots) — the soul
  fontDisplay: { fontFamily: "'Fraunces', serif" },
  // Sans for functional UI — clean, readable
  fontBody: { fontFamily: "'Inter', sans-serif" },
};

// ─── SHARED COMPONENTS ──────────────────────────────────────

export { S, css, applyTheme, THEME_STORAGE_KEY, initialTheme };
